import { toast } from "sonner";

const ACTION_FALLBACK = "Não foi possível concluir a ação.";

export function errorCode(error: unknown) {
	if (typeof error !== "object" || error === null) {
		return;
	}

	const raw = (error as { code?: unknown }).code;

	if (typeof raw === "string") {
		return raw;
	}
}

export function actionError(map: Record<string, string>, code: string | undefined) {
	if (code === undefined) {
		return ACTION_FALLBACK;
	}

	return map[code] ?? ACTION_FALLBACK;
}

export function notifyError(toLabel: (code: string | undefined) => string) {
	return (error: unknown) => {
		toast.error(toLabel(errorCode(error)));
	};
}
